<template>
  <div class="lead-managers">
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="last60Days"
          @is-hidden="fetchAllAnalytics"
          @input="onInputPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          ref="date_picker"
        />
      </div>
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Summary</h2></app-cells>
      <div class="lead-managers__conversion lead-managers__conversion--indent">
        <div class="lead-managers__diagram">
          <div class="lead-managers__diagram-piece left" :class="{'over50': summary.conversion.conversion_rate >= 50}"></div>
          <div class="lead-managers__diagram-piece right" :class="{'over50': summary.conversion.conversion_rate >= 50}" :style="{'transform': `rotate(${(360 * summary.conversion.conversion_rate / 100) + 180}deg)` }"></div>
          <span class="lead-managers__diagram-text">{{ summary.conversion.conversion_rate }}%</span>
        </div>
        <div class="lead-managers__conversion-grid lead-managers__conversion-grid--4">
          <strong>Conversion rate</strong>
          <strong>Total sales</strong>
          <strong>Upcoming</strong>
          <strong>Completed</strong>
          <div class="lead-managers__conversion-line"><span>Requests:</span><b>{{ summary.conversion.conversion_requests }}</b></div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-amount.svg" alt="Amount">
            <span class="lead-managers__row-value">{{ summary.total_sales.amount.toLocaleString() }}$</span>
          </div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-amount.svg" alt="Amount">
            <span class="lead-managers__row-value">{{ summary.confirmed.amount.toLocaleString() }}$</span>
          </div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-amount.svg" alt="Amount">
            <span class="lead-managers__row-value">{{ summary.completed.amount.toLocaleString() }}$</span>
          </div>
          <div class="lead-managers__conversion-line"><span>Confirmed:</span><b>{{ summary.conversion.conversion_confirmed }}</b></div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-commission.svg" alt="Commission">
            <span class="lead-managers__row-value">{{ summary.total_sales.commission.toLocaleString() }}$</span>
          </div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-commission.svg" alt="Commission">
            <span class="lead-managers__row-value">{{ summary.confirmed.commission.toLocaleString() }}$</span>
          </div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-commission.svg" alt="Commission">
            <span class="lead-managers__row-value">{{ summary.completed.commission.toLocaleString() }}$</span>
          </div>
          <div></div>
          <div class="lead-managers__amount">
            <img src="@/assets/img/lead-discount.svg" alt="Commission">
            <span class="lead-managers__row-value">{{ summary.total_sales.discounts.toLocaleString() }}$</span>
          </div>
        </div>
      </div>
      <div class="charts-grid"><highcharts :options="graph_managers_options" /></div>
      <div class="lead-managers__table lead-managers__table--grid">
        <div class="lead-managers__row-holder" v-for="(status, index) of status_list" :key="status.name">
          <button class="lead-managers__row-head" @click="summary[status.fieldName].show_activities = !summary[status.fieldName].show_activities" type="button">
              <span>
                <span class="lead-managers__row-value lead-managers__row-value--tag" :style="{ 'backgroundColor': status.color }">{{ status.name }}</span>
              </span>
            <span class="lead-managers__row-value">{{ summary[status.fieldName].count }} ({{ summary[status.fieldName].pax }})</span>
            <div class="lead-managers__row-amounts">
              <div class="lead-managers__row-amount">
                <img src="@/assets/img/lead-amount.svg" alt="Amount">
                <span class="lead-managers__row-value">{{ summary[status.fieldName].amount.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__row-amount">
                <img src="@/assets/img/lead-commission.svg" alt="Commission">
                <span class="lead-managers__row-value">{{ summary[status.fieldName].commission.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__row-amount">
                <img src="@/assets/img/lead-discount.svg" alt="Discount">
                <span class="lead-managers__row-value">{{ summary[status.fieldName].discounts.toLocaleString() }}$</span>
              </div>
            </div>
            <span class="lead-managers__row-switcher" :class="{'lead-managers__row-switcher--show': summary[status.fieldName].show_activities}"></span>
          </button>
          <div
            class="lead-managers__row-activities"
            :class="{
                'lead-managers__row-activities--show': summary[status.fieldName].show_activities,
                'lead-managers__row-activities--left': index === 8,
                'lead-managers__row-activities--right': index === 9
              }"
          >
            <div class="lead-managers__row-activities-row">
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-climbing.svg" alt="Amount">
                  <span class="lead-managers__row-value">Climbing:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.climbing.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.climbing.commission.toLocaleString() }}$</span>
                </div>
              </div>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-safari.svg" alt="Safari">
                  <span class="lead-managers__row-value">Safari:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.safari.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.safari.commission.toLocaleString() }}$</span>
                </div>
              </div>
            </div>
            <div class="lead-managers__row-activities-row">
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-daytrips.svg" alt="Amount">
                  <span class="lead-managers__row-value">Daytrips:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.daytrips.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.daytrips.commission.toLocaleString() }}$</span>
                </div>
              </div>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-islands.svg" alt="Safari">
                  <span class="lead-managers__row-value">Islands:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.islands.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.islands.commission.toLocaleString() }}$</span>
                </div>
              </div>
            </div>
            <div class="lead-managers__row-activities-row">
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-transfers.svg" alt="Amount">
                  <span class="lead-managers__row-value">Transfers:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.transfers.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.transfers.commission.toLocaleString() }}$</span>
                </div>
              </div>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-flight.svg" alt="Safari">
                  <span class="lead-managers__row-value">Flights:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.flights.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.flights.commission.toLocaleString() }}$</span>
                </div>
              </div>
            </div>
            <div class="lead-managers__row-activities-row">
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-hotels.svg" alt="Amount">
                  <span class="lead-managers__row-value">Hotels:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.extra_accommodation.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.extra_accommodation.commission.toLocaleString() }}$</span>
                </div>
              </div>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-services.svg" alt="Safari">
                  <span class="lead-managers__row-value">Services:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.additional_services.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.additional_services.commission.toLocaleString() }}$</span>
                </div>
              </div>
            </div>
            <div class="lead-managers__row-activities-row">
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-airport.svg" alt="Amount">
                  <span class="lead-managers__row-value">Airport VIP:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.airport_vip_service.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.airport_vip_service.commission.toLocaleString() }}$</span>
                </div>
              </div>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-other.svg" alt="Safari">
                  <span class="lead-managers__row-value">Other:</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.other.amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ summary[status.fieldName].activities.other.commission.toLocaleString() }}$</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-cells><h2 class="title">Managers</h2></app-cells>
      <div v-for="manager of managers_data" :key="manager.id"  class="lead-managers__part">
        <div class="lead-managers__manager lead-managers__fstart">
          <div class="lead-managers__photo">
            <div class="lead-managers__avatar">
              <img :src="getUserAvatar(manager.manager.crop.crop_url)" alt="Avatar">
            </div>
            <div class="lead-managers__info">
              <span class="lead-managers__name">{{ manager.manager.full_name }}</span>
              <span class="lead-managers__position">Sales manager</span>
              <span class="lead-managers__seniority">{{ manager.seniority || 'No employment date' }}</span>
            </div>
          </div>
          <div class="lead-managers__conversion lead-managers__fstart">
            <div class="lead-managers__diagram">
              <div class="lead-managers__diagram-piece left" :class="{'over50': manager.conversion.rate >= 50}"></div>
              <div class="lead-managers__diagram-piece right" :class="{'over50': manager.conversion.rate >= 50}" :style="{'transform': `rotate(${(360 * manager.conversion.rate / 100) + 180}deg)` }"></div>
              <span class="lead-managers__diagram-text">{{ manager.conversion.rate }}%</span>
            </div>
            <div class="lead-managers__conversion-grid lead-managers__conversion-grid--4">
              <strong>Conversion rate</strong>
              <strong>Total sales</strong>
              <strong>Upcoming</strong>
              <strong>Completed</strong>
              <div class="lead-managers__conversion-line"><span>Requests:</span><b>{{ manager.conversion.requests }}</b></div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-amount.svg" alt="Amount">
                <span class="lead-managers__row-value">{{ manager.total_sales.amount.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-amount.svg" alt="Amount">
                <span class="lead-managers__row-value">{{ manager.confirmed.amount.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-amount.svg" alt="Amount">
                <span class="lead-managers__row-value">{{ manager.completed.amount.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__conversion-line"><span>Confirmed:</span><b>{{ manager.conversion.confirmed }}</b></div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-commission.svg" alt="Commission">
                <span class="lead-managers__row-value">{{ manager.total_sales.commission.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-commission.svg" alt="Commission">
                <span class="lead-managers__row-value">{{ manager.confirmed.commission.toLocaleString() }}$</span>
              </div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-commission.svg" alt="Commission">
                <span class="lead-managers__row-value">{{ manager.completed.commission.toLocaleString() }}$</span>
              </div>
              <div></div>
              <div class="lead-managers__amount">
                <img src="@/assets/img/lead-discount.svg" alt="Commission">
                <span class="lead-managers__row-value">{{ manager.total_sales.discounts.toLocaleString() }}$</span>
              </div>
            </div>
          </div>
        </div>
        <div class="lead-managers__table lead-managers__table--grid">
          <div class="lead-managers__row-holder" v-for="(status, index) of status_list" :key="status.name">
            <button class="lead-managers__row-head" @click="manager[status.fieldName].show_activities = !manager[status.fieldName].show_activities" type="button">
              <span>
                <span class="lead-managers__row-value lead-managers__row-value--tag" :style="{ 'backgroundColor': status.color }">{{ status.name }}</span>
              </span>
              <span class="lead-managers__row-value">{{ manager[status.fieldName].count }} ({{ manager[status.fieldName].pax }})</span>
              <div class="lead-managers__row-amounts">
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-amount.svg" alt="Amount">
                  <span class="lead-managers__row-value">{{ manager[status.fieldName].amount.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-commission.svg" alt="Commission">
                  <span class="lead-managers__row-value">{{ manager[status.fieldName].commission.toLocaleString() }}$</span>
                </div>
                <div class="lead-managers__row-amount">
                  <img src="@/assets/img/lead-discount.svg" alt="Discount">
                  <span class="lead-managers__row-value">{{ manager[status.fieldName].discounts.toLocaleString() }}$</span>
                </div>
              </div>
              <span class="lead-managers__row-switcher" :class="{'lead-managers__row-switcher--show': manager[status.fieldName].show_activities}"></span>
            </button>
            <div
              class="lead-managers__row-activities"
              :class="{
                'lead-managers__row-activities--show': manager[status.fieldName].show_activities,
                'lead-managers__row-activities--left': index === 8,
                'lead-managers__row-activities--right': index === 9
              }"
            >
              <div class="lead-managers__row-activities-row">
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-climbing.svg" alt="Amount">
                    <span class="lead-managers__row-value">Climbing:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.climbing.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.climbing.commission.toLocaleString() }}$</span>
                  </div>
                </div>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-safari.svg" alt="Safari">
                    <span class="lead-managers__row-value">Safari:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Commission">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.safari.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.safari.commission.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
              <div class="lead-managers__row-activities-row">
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-daytrips.svg" alt="Amount">
                    <span class="lead-managers__row-value">Daytrips:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.daytrips.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.daytrips.commission.toLocaleString() }}$</span>
                  </div>
                </div>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-islands.svg" alt="Safari">
                    <span class="lead-managers__row-value">Islands:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Commission">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.islands.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.islands.commission.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
              <div class="lead-managers__row-activities-row">
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-transfers.svg" alt="Amount">
                    <span class="lead-managers__row-value">Transfers:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.transfers.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.transfers.commission.toLocaleString() }}$</span>
                  </div>
                </div>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-flight.svg" alt="Safari">
                    <span class="lead-managers__row-value">Flights:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Commission">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.flights.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.flights.commission.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
              <div class="lead-managers__row-activities-row">
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-hotels.svg" alt="Amount">
                    <span class="lead-managers__row-value">Hotels:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.extra_accommodation.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.extra_accommodation.commission.toLocaleString() }}$</span>
                  </div>
                </div>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-services.svg" alt="Safari">
                    <span class="lead-managers__row-value">Services:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Commission">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.additional_services.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.additional_services.commission.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
              <div class="lead-managers__row-activities-row">
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-airport.svg" alt="Amount">
                    <span class="lead-managers__row-value">Airport VIP:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Climbing">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.airport_vip_service.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.airport_vip_service.commission.toLocaleString() }}$</span>
                  </div>
                </div>
                <div class="lead-managers__row-amounts">
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-other.svg" alt="Safari">
                    <span class="lead-managers__row-value">Other:</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-amount.svg" alt="Commission">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.other.amount.toLocaleString() }}$</span>
                  </div>
                  <div class="lead-managers__row-amount">
                    <img src="@/assets/img/lead-commission.svg" alt="Discount">
                    <span class="lead-managers__row-value">{{ manager[status.fieldName].activities.other.commission.toLocaleString() }}$</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getLeadsAnalyticsManagers,
  getLeadsAnalyticsManagersSummary,
  getLeadsAnalyticsRequestsManagersGraph
} from '@/http'
import { Chart as highcharts } from 'highcharts-vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  name: 'CRMAnalyticsManagers',
  components: {highcharts, VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      custom_shortcuts: [
        { key: 'thisMonth', label: 'This month', value: 'month' },
        { key: 'lastMonth', label: 'Last month', value: '-month' },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      managers_data: [],
      summary: {},
      status_list: [
        {name: 'Lead', fieldName: 'lead', color: '#1DB748'},
        {name: 'Nurture', fieldName: 'nurture', color: '#000080'},
        {name: 'Negotiation', fieldName: 'negotiation', color: '#DD5082'},
        {name: 'Pre confirmed', fieldName: 'pre_confirmed', color: '#A95AC5'},
        {name: 'Deposit paid', fieldName: 'deposit', color: '#3DC5C5'},
        {name: 'Full paid', fieldName: 'full_paid', color: '#256DC1'},
        {name: 'Postponed', fieldName: 'postponed', color: '#DEA000'},
        {name: 'Refused', fieldName: 'refused', color: '#E85C20'},
        {name: 'No response', fieldName: 'no_response', color: '#FC9721'},
        {name: 'Lost', fieldName: 'lost', color: '#E85C20'},
      ],
      graph_managers_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
    }
  },
  methods: {
    onInputPicker() {
      if (!this.$refs.date_picker.pickerOpen) this.fetchAllAnalytics()
    },
    fetchAllAnalytics() {
      Promise.all([
        this.fetchManagersAnalytics(),
        this.fetchSummaryAnalytics(),
        this.fetchManagersGraph()
      ]).then(() => { this.is_loaded = true })
    },
    async fetchManagersAnalytics() {
      const response = await getLeadsAnalyticsManagers(
        {
          from_date: this.filter_dates?.start,
          to_date: this.filter_dates?.end
        })
      this.managers_data = response.data
    },
    async fetchSummaryAnalytics() {
      const response = await getLeadsAnalyticsManagersSummary(
        {
          from_date: this.filter_dates?.start,
          to_date: this.filter_dates?.end
        })
      this.summary = response.data
    },
    async fetchManagersGraph() {
      const response = await getLeadsAnalyticsRequestsManagersGraph(
        {
          from_date: `${new Date().getFullYear()}-01-01`,
          to_date: `${new Date().getFullYear()}-12-31`
        })
      this.graph_managers_options.xAxis.categories = response.data.categories
      this.graph_managers_options.series = response.data.series
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug2.jpg')
    },
  }
}
</script>

